module.exports = __webpack_public_path__ + "img/icon_pin.ea61c934.svg";